import { render, staticRenderFns } from "./Report-services.vue?vue&type=template&id=1d1a96a6&scoped=true"
import script from "./Report-services.vue?vue&type=script&lang=js"
export * from "./Report-services.vue?vue&type=script&lang=js"
import style0 from "./Report-services.vue?vue&type=style&index=0&id=1d1a96a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1a96a6",
  null
  
)

export default component.exports